import type GlobalPopup from '../models'

export interface PopupStorageData {
    id: number
    displayFrequency: number
    dateCanShow: number
}

export const getUpdatedStorageData = (
    popupStorageDataArray: PopupStorageData[] = [],
    pagePopup: GlobalPopup,
    popupId: number
): PopupStorageData[] | undefined => {
    const createPopupStorageData = (newPopupId: number) => {
        const dateCanShow = new Date()
        dateCanShow.setMinutes(0)
        dateCanShow.setHours(0)
        dateCanShow.setDate(dateCanShow.getDate() + (pagePopup.displayFrequencyInDays || 0))
        return {
            id: newPopupId,
            displayFrequency: pagePopup.displayFrequencyInDays ?? 0,
            dateCanShow: dateCanShow.valueOf(),
        }
    }

    let popupRecordExists = false

    const updatedStorageData = popupStorageDataArray.map((popup: PopupStorageData) => {
        if (popup.id === popupId) {
            popupRecordExists = true
            return createPopupStorageData(popupId)
        }
        return popup
    })

    if (popupRecordExists) return [...updatedStorageData]

    return [...updatedStorageData, createPopupStorageData(popupId)]
}

export default getUpdatedStorageData
